export default class Sportler {
    Prim = 0;
    Name = "";
    Vorname = "";
    Geburtsdatum = "";
    RefGeschlechter = 0;
    RefGraduierung = 0;
    RefVereine = 0;
    RefParaklasse = 0;
    Kadermitglied = false;
}
